/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @author Yakov Gushchin
 * @version 1.20.1
 * @since 1.14.0
 */

import { IWizardChangeLockReducer } from './wizardChangeLockReducer';

export enum EWizardChangeLockSteps {
    StepOperationSelection = 'OperationSelectionStep',
    StepDateSelection = 'DateSelectionStep',
    StepConfirmation = 'ConfirmStep',
}

export enum EWizardChangeLockFieldList {
    COST = 'cost',
    DELETE = 'delete',
    MSISDN = 'msisdn',
    STATUS = 'status',
}

export enum EWizardChangeLockOperationType {
    LOCK = 'LOCK',
    UNLOCK = 'UNLOCK',
}

export const initWizardChangeLockState: IWizardChangeLockReducer = {
    dateFrom: '',
    dateTo: '',
    isOnlineCheckProceeded: false,
    isUnlockSubscribers: false,
    lockParameters: {
        dateCanNow: false,
        dateFrom: '',
        dateFromEnd: '',
        dateTo: '',
        dateToEnd: '',
        dateToStart: '',
    },
    maxLockingPeriod: 0,
    orderCheckResult: {
        sumCharge: 0,
        orderSubs: [],
    },
    removedSubscribers: [],
    subscriberIds: [],
    validation: {
        error: '',
        isValid: false,
    },
};

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const WIZARD_CHANGE_LOCK_HANDLE_NEXT = '@@b2b_portal_ui/wizardChangeLock/WIZARD_CHANGE_LOCK_HANDLE_NEXT';

export const WIZARD_CHANGE_LOCK_SET_PARAMS = '@@b2b_portal_ui/wizardChangeLock/WIZARD_CHANGE_LOCK_SET_PARAMS';

export const WIZARD_CHANGE_LOCK_START_VALIDATE = '@@b2b_portal_ui/wizardChangeLock/WIZARD_CHANGE_LOCK_START_VALIDATE';
export const WIZARD_CHANGE_LOCK_SET_STEP_VALID = '@@b2b_portal_ui/wizardChangeLock/WIZARD_CHANGE_LOCK_SET_STEP_VALID';
